import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, CssBaseline } from "@mui/material";

import Topbar from "../../../../components/topbar/TopBar";
import Header from "../../../../components/header/Header";
import FormVehicle from "../form/FormVehicle";
//sidebar
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme as themeStyles } from "@mui/material/styles";
import Sidebar from "../../../../components/sidebar/Sidebar";

const AddVehicle = () => {
  const { t } = useTranslation();
  const themeSidebar = themeStyles();
  const matchesSM = useMediaQuery(themeSidebar.breakpoints.down("sm"));

  return (
    <div>
      <CssBaseline />
      <div className="app">
        {!matchesSM && <Sidebar />}
        <main className="content">
          <Topbar />
          <Box m="5px">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Header title={t("addVehicle")} subtitle="" />
            </Box>
            <Box>
              <Box>
                <FormVehicle />
              </Box>
            </Box>
          </Box>
        </main>
      </div>
    </div>
  );
};

export default AddVehicle;
